import React from 'react';

import { NextPageWithLayout } from 'next';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { CatchIconGreen } from '../../../components/Icons/CatchIconGreen';
import { CatchIconRed } from '../../../components/Icons/CatchIconRed';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import { Text } from '../../../components/Text/Text';
import { CircleImageAndText } from '../components/CircleImageAndText';

import phoneOne from './assets/phoneOne.png';
import phoneThree from './assets/phoneThree.png';
import phoneTwo from './assets/phoneTwo.png';
import { HeaderSection } from '../components/HeaderSection';
import {
  META_FISHING_LOG_A_CATCH_TITLE,
  META_FISHING_LOG_A_CATCH_DESCRIPTION,
  META_FISHING_LOG_A_CATCH_CANONICAL,
} from '../../../constants/metadata';

export const LogACatchPage: NextPageWithLayout = () => {
  return (
    <div>
      <MetaTags
        title={META_FISHING_LOG_A_CATCH_TITLE}
        description={META_FISHING_LOG_A_CATCH_DESCRIPTION}
        link={META_FISHING_LOG_A_CATCH_CANONICAL}
      />

      <HeaderSection
        headingText="Log your catches in the Fishbrain app"
        bodyText="Keep track of every fish you catch and use insights to help you fish smarter with our
          logbook feature in the Fishbrain app."
      />

      <CircleImageAndText
        imgSrc={phoneOne}
        imgAlt="Your personal fishing logbook with the Fishbrain app"
        headingText="Your personal fishing logbook"
        bodyText="Every time your record a catch, the Fishbrain app will help you keep track of details you want to remember like weather and water conditions, catch times, locations, and baits that you use. All details are kept as private as you choose."
      />

      <div className="bg-lake-fog">
        <Container className="mt-md py-sm md:py-md flex flex-col sm:flex-row md:justify-center">
          <div className="sm:w-col-6 md:w-col-5">
            <Heading variant="md" className="mr-24 mt-4">
              Set your privacy level
            </Heading>
            <Text variant="lg" className="mb-5 mt-4">
              With Fishbrain, you can select the privacy level you choose for every catch you log.
              We make sure you never have to give away locations unless you decide to do so.
            </Text>
          </div>

          <div className="sm:w-col-6 md:w-col-5 sm:pl-8">
            <div className="mb-2 flex">
              <div>
                <CatchIconGreen className="mr-2" />
              </div>
              <div>
                <Text className="mb-0 font-semibold">Public catch location</Text>
                <Text>Exact location and water name is visible to everyone</Text>
              </div>
            </div>
            <div className="mb-2 flex">
              <div>
                <CatchIconRed className="mr-2" />
              </div>
              <div>
                <Text className="mb-0 font-semibold">Only share water name</Text>
                <Text>Exact location is only visible to you, water name is public</Text>
              </div>
            </div>
            <div className="flex">
              <div>
                <CatchIconRed className="mr-2" />
              </div>
              <div>
                <Text className="mb-0 font-semibold">Private - only share catch details</Text>
                <Text>Visible to only you</Text>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <CircleImageAndText
        imgSrc={phoneTwo}
        imgAlt="Keep track of your catches in one place with the Fishbrain app"
        headingText="Keep track of your catches in one place"
        bodyText="Track your species count, weight, and length of your catches and log the baits you use by saving your catch details in your profile."
      />

      <CircleImageAndText
        imgSrc={phoneThree}
        imgRight
        imgAlt="Learn from personal insights with the Fishbrain app"
        headingText="Learn from personal insights"
        bodyText="With Fishbrain Pro, you can access your personal statistics to see what conditions lead to your best performance. Fish like a Pro with access to your most active month, moon phases, and weather conditions."
      />

      <AppDownloadSection />
    </div>
  );
};
